import { Route, Switch } from "react-router-dom";
import { PATH_BULK_REVIEW_REQUIREMENTS } from "./paths";
import { RouteBulkReviewRequirements } from "./routes/RouteBulkReviewRequirements";

export const BulkReviewIndex = () => {
  return (
    <Switch>
      <Route
        path={PATH_BULK_REVIEW_REQUIREMENTS}
        exact
        component={RouteBulkReviewRequirements}
      />
    </Switch>
  );
};
